import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material';
import { colorPalette } from '@repo/mui-config/color-palette';
import p24LogoUrl from '@repo/assets/images/przelewy-24-logo.svg?url';

interface ModalHeaderElementProps {
  onClick: () => void;
}

interface LoanProcessModalHeaderProps {
  closeButton?: ModalHeaderElementProps;
  containerSx?: SxProps<Theme>;
}

export function LoanProcessModalHeader({ closeButton, containerSx }: LoanProcessModalHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        ...containerSx,
      }}
    >
      <Box
        component="img"
        src={p24LogoUrl}
        alt="p24 logo"
        height={50}
        sx={{ margin: '0 auto', display: 'flex' }}
      />
      {closeButton ? (
        <IconButton
          onClick={closeButton.onClick}
          sx={{
            color: colorPalette.black,
            p: 0,
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          <Box
            component="span"
            sx={{
              p: '6px',
              borderRadius: '50%',
              display: 'flex',
              justifySelf: 'center',
              color: colorPalette.black,
              backgroundColor: colorPalette.cloud.light,
            }}
          >
            <CloseIcon fontSize="small" />
          </Box>
        </IconButton>
      ) : null}
    </Box>
  );
}
